exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-field[data-v-414938da]{height:100px}.note-detail[data-v-414938da]{transition:max-height .7s;max-height:60px;overflow:hidden}.note-wrap:hover .note-detail[data-v-414938da]{max-height:157px;overflow:auto}.note-wrap[data-v-414938da]{padding-left:10px;border-left:1px dashed #6f2971;position:relative}.note-wrap[data-v-414938da]:before{content:\"\";display:inline-block;width:8px;height:8px;border-radius:16px;background-color:#6f2971;position:absolute;left:-4px;top:10px}.files_list_container[data-v-414938da]{padding-left:5px}", ""]);

// exports
